export default __webpack_public_path__ + "static/media/co-sticker.8b0c68a4.png";